
export function Term(){
  return (
    <div id="term">
      <div className="container">
        <div className="section-title text-center">
          <h2>Terms and Conditions for GPS Maps Navigation</h2>
        </div>
        <h3> Effective Date: August 4, 2025</h3>
        <p>
          Please read these Terms and Conditions (“Terms”, “Terms and
          Conditions”) carefully before using the GPS Maps Navigation app
          (“App”, “Service”) operated by Talymind Apps LTD (“Company”, “we”,
          “us”, or “our”). By downloading or using the App, you agree to be
          bound by these Terms. If you do not agree to the Terms, do not use the
          App.
        </p>
        <h3>Use of App</h3>
        <p>
          You may use the App for personal and non-commercial purposes under
          these Terms and applicable laws. You must not misuse the App or
          interfere with its operation.
        </p>
        <p>
          <h3>User Responsibilities</h3>
          <p>
            You may use the App for personal and non-commercial purposes under
            these Terms and applicable laws. You must not misuse the App or
            interfere with its operation.
          </p>

          <ui>
            <li>
              {" "}
              You are responsible for ensuring that your device is compatible
              with the App.{" "}
            </li>
            <li>
              {" "}
              You must not use the App while driving or in any way that
              distracts from the safe operation of a vehicle.
            </li>
            <li>
              {" "}
              You agree not to use the App for unlawful purposes or to violate
              any applicable local, state, national, or international law.
            </li>
          </ui>
        </p>
        <h3>Location-Based Services </h3>
        Our App uses GPS and other location technologies to provide navigation
        and related services. You must allow location access for the App to
        function correctly. Location data is processed in real-time and not
        stored by us.
        <h3>Third-Party Services </h3>
        <li>Firebase Analytics</li>
        <li>Google AdMob</li>
        <li> Firebase</li>
        <li>Mapbox</li>
        <p>
          We are not responsible for the practices or content of third-party
          services.
        </p>
        <h3> Intellectual Property</h3> All App content, features, and
        functionality (including maps, icons, UI elements, and branding) are
        owned by Talymind Apps LTD or its licensors and are protected by
        copyright, trademark, and other laws.
        <ol>
          You may not copy, modify, distribute, sell, or lease any part of our
          App without our permission.
        </ol>
        <h3>Advertisements</h3> The App may display advertisements via Google
        AdMob. By using the App, you consent to receive such ads. Ad relevance
        and frequency are managed by Google’s ad network based on app usage.
        <h3>Disclaimers</h3>
        <li>The App is provided “as is” without warranties of any kind.</li>
        <li>
          We do not guarantee the accuracy, reliability, or availability of
          navigation routes, maps, or third-party data.
        </li>
        <li>
          We are not liable for any direct or indirect damages resulting from
          the use or inability to use the App.
        </li>
        <h3>Limitation of Liability</h3>To the maximum extent permitted by law,
        Talymind Apps LTD shall not be liable for any damages resulting from:
        <li>Inaccurate map data or navigation instructions</li>
        <li> Network or GPS service interruptions.</li>
        <li>Third-party service failures.</li>
        <p>Use the App at your own risk.</p>
        <h3>Termination </h3>We reserve the right to terminate or suspend your
        access to the App without notice if you violate these Terms or if we
        discontinue the App.
        <h3>Changes to Terms</h3>We may update these Terms at any time. Updated
        terms will be posted within the App or on this page with the revised
        date. Continued use of the App indicates acceptance of the updated
        Terms.
        <h3> Governing Law </h3>These Terms are governed by the laws of your
        country, without regard to its conflict of law provisions.
        <h3>Contact Us </h3>If you have any questions or concerns about this
        Privacy Policy, please contact us at: 📧 info@Jarvastech.com 📌 Jarvas
        Tech LTD
      </div>
    </div>
  );
};